import { render, staticRenderFns } from "./ProductImageRemoveBGModal.vue?vue&type=template&id=cb533b2a"
import script from "./ProductImageRemoveBGModal.vue?vue&type=script&lang=js"
export * from "./ProductImageRemoveBGModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports